import { render } from "./ComponentCompany.vue?vue&type=template&id=419e65b4&scoped=true"
import script from "./ComponentCompany.vue?vue&type=script&lang=js"
export * from "./ComponentCompany.vue?vue&type=script&lang=js"

import "./ComponentCompany.vue?vue&type=style&index=0&id=419e65b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419e65b4"]])

export default __exports__